import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type CreditCardFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const CreditCardFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: CreditCardFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-2.043031 -1.521364) scale(1.120311)',
        },
        [
          h(
            'path',
            {
              d: 'M20.8827 20.8451H4.18721C3.00517 20.8451 2.04678 19.8869 2.04678 18.7046V10.5709H23.0231V18.7046C23.0231 19.8869 22.0647 20.8451 20.8827 20.8451ZM15.3175 15.2799L14.4613 18.2765H19.5983L20.4545 15.2799H15.3175ZM2.04678 5.43392C2.04678 4.25188 3.00517 3.29349 4.18721 3.29349H20.8826C22.0647 3.29349 23.0231 4.25188 23.0231 5.43392V7.57439L2.04678 7.57439V5.43392Z',
            },
          ),
        ],
      ),
    ],
  );

export default CreditCardFilled;
